export default {
  name: 'Aauthority',
  render() {
    const r = this.$attrs;
    const code = r.number || r.value || r.code || r.id || null;
    const access = r.options || r.option || r.config || r.access || r.routes || r.values || r.items || r.list || r.data || null;
    if (access) return (access.includes(code) && this.$slots.default);
  }
}